module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alarms":"Alarms","triggered_alarms":"Triggered Alarms","add_alm":"Add Alarm","all-rights":"All Rights Reserved"},"fr":{"alarms":"Alarmes","triggered_alarms":"Alarmes Déclenchées","add_alm":"Ajouter une alarme","all-rights":"Tous droits réservés"}}')
  delete Component.options._Ctor
}
